import React from 'react'
import styles from '../component/custom.module.css';
import Images from './Images';


const HelpSection = ({JurySelectScroll}) => {
    return (
    <section className={styles.HelpSection}>
        <div className='container'>
            <div className={styles.HelpSectionInner}>
                <img className={styles.HelpDarkCom} src={Images.LogoHeaderV3} alt='SOYF' style={{ minWidth: '64px', maxWidth: '188px' }} />
                <span>Stand on Your Feet.</span>
                <h2>We at <b>moha</b>: Believe That We  <br/> Can Help You </h2>
                <p><b>moha: Stand on Your Feet</b> Initiative is aimed at helping women <br/>entrepreneurs to work towards their entrepreneurial goals through <br/>
                early stage seed funding and mentorship. This program is designed to <br/>identify and empower that one woman entrepreneur who can make a <br/>
                difference and help her with a grant of Rs. 15 Lakhs! Let the best  <br/> woman win!  </p>
                {/* <div className={styles.scrollDown} onClick={JurySelectScroll} style={{cursor:"pointer"}}>
                    <p>Scroll</p>
                    <img src={Images.ScrollDown} />    
                </div> */}
            </div>
        </div>
    </section>
    
    );
  };
  
  export default HelpSection;

